import { render, staticRenderFns } from "./background.vue?vue&type=template&id=d59af310&scoped=true&"
var script = {}
import style0 from "./background.vue?vue&type=style&index=0&id=d59af310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59af310",
  null
  
)

export default component.exports